import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import Input from '../../../../../ui/canon/Input';
import { SendIcon, PhoneIcon } from 'lucide-react';

const TelWidget = ({
  onAnswer,
  disabled,
  placeholder = 'Enter phone number...',
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setValue(initialValue || '');
    setIsSubmitting(false);
    setError('');
  }, [initialValue]);

  const formatPhoneNumber = (input) => {
    // Remove all non-digit characters
    const digits = input.replace(/\D/g, '');

    // Format as (XXX) XXX-XXXX for 10 digits
    if (digits.length <= 3) {
      return digits;
    } else if (digits.length <= 6) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else if (digits.length <= 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else {
      // For international numbers, just show with country code
      return `+${digits.slice(0, digits.length - 10)} (${digits.slice(-10, -7)}) ${digits.slice(-7, -4)}-${digits.slice(-4)}`;
    }
  };

  const validatePhone = (phone) => {
    if (!phone.trim()) return '';
    const digits = phone.replace(/\D/g, '');
    if (digits.length < 10) {
      return 'Please enter a valid phone number (at least 10 digits)';
    }
    return '';
  };

  const handleChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    setValue(formatted);
    if (error) {
      setError(validatePhone(formatted));
    }
  };

  const handleBlur = () => {
    setError(validatePhone(value));
  };

  const handleSubmit = () => {
    const validationError = validatePhone(value);
    if (validationError) {
      setError(validationError);
      return;
    }

    if (value.trim() && !isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: value.trim() });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const isValid = value.trim() && !validatePhone(value);

  return (
    <div className="space-y-3">
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-succession-text-muted">
          <PhoneIcon className="h-4 w-4" />
        </div>
        <Input
          type="tel"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled || isSubmitting}
          className="pl-10"
        />
      </div>
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
      <Button
        onClick={handleSubmit}
        disabled={!isValid || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        Submit Answer
      </Button>
    </div>
  );
};

export default TelWidget;
